<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex align-center">
            <span class="text-h5">Gestion des Stocks</span>
          </v-card-title>
          
          <v-divider></v-divider>
          
          <v-card-text>
            <!-- Filtres -->
            <v-row>
                <v-col cols="12" md="3">
                    <v-switch label="Regrouper" v-model="regroupe"></v-switch>
                </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="search"
                  label="Rechercher"
                  prepend-inner-icon="mdi-magnify"
                  variant="outlined"
                  density="compact"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="filterGpLibrePiece"
                  :items="gpLibrePieceOptions"
                  label="Filtrer par Pièce"
                  variant="outlined"
                  density="compact"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" class="text-right">
                <v-chip color="info" variant="flat">
                  Total: {{ items.length }} lignes
                </v-chip>
                <!-- <v-chip color="success" variant="flat" class="ml-2">
                  Groupes: {{ groupedData.length }}
                </v-chip> -->
              </v-col>
            </v-row>

            <!-- Tableau des données groupées -->
            <v-data-table
              :headers="headers"
              :group-by="groupBy"
              :items="groupedData"
              :search="search"
              :loading="loading"
              :items-per-page="15"
              :items-per-page-options="[5, 10, 15, 25, 50]"
              class="elevation-1"
              density="compact"
              
            >

              <!-- <template v-slot:group-header="{ groupBy, group, headers, isOpen, toggle }">
              <td :colspan="headers.length" class="text-left">
                <v-btn
                  variant="text"
                  size="small"
                  :prepend-icon="isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'"
                  @click="toggle"
                >
                  <strong>{{ group }}</strong>
                  <span class="ml-2 text-caption text-grey">
                    ({{ groupBy }})
                  </span>
                </v-btn>
              </td>
            </template> -->
                      <!-- Colonne gp_librepiece3 -->
              <template v-slot:item.gp_librepiece3="{ item }">
                <v-chip color="primary" variant="tonal" size="small">
                  {{ item.gp_librepiece3 }}
                </v-chip>
              </template>

              <!-- Colonne ga_codearticle -->
              <template v-slot:item.ga_codearticle="{ item }">
                <v-chip color="secondary" variant="tonal" size="small" @click="ouvrirPopUpPhotos(item)">
                  {{ item.ga_codearticle }}
                </v-chip>
              </template>

              <!-- Colonne couleur -->
              <template v-slot:item.couleur="{ item }">
                <div class="d-flex align-center">
                  <span>{{ item.couleur || 'N/A' }}</span>
                </div>
              </template>
              <!-- <template v-slot:item.cab_secondaire="{ item }">
                <div class="d-flex align-center" @click="ouvrirPopUpPhotos(item)">
                  <span>{{ item.cab_secondaire || 'N/A' }}</span>
                </div>
              </template> -->

              <!-- Colonne qté avec barre de progression -->
              <template v-slot:item.gl_qtestock="{ item }">
                <div class="d-flex align-center">
                  <span class="font-weight-bold">{{ item.gl_qtestock }}</span>
                </div>
              </template>
            </v-data-table>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
      <PhotosFripe v-if="popupVisible"
      v-model="popupVisible"
      :article="articlePhoto"
      :photosTab="photosFripe"
      ></PhotosFripe>
    
  </v-container>
  
</template>

<script setup>
import store from '@/store'
import axios from 'axios'
import { ref, computed, onMounted } from 'vue'
import PhotosFripe from './PhotosFripe.vue'
// === Props ===
const props = defineProps({
  mockData: {
    type: Array,
    default: () => []
  }
})
let regroupe=ref(false)
// === État ===
const items = ref([])
const loading = ref(false)
const search = ref('')
const filterGpLibrePiece = ref(null)
const popupVisible = ref(false)
let srcImage=ref()
let photosFripe=ref({
  photos:[],
  firstPhoto:'',
  PhotosCount:0
})
const photo_name = ref('')
const ouvrirPopUpPhotos = async (item) => {
  photo_name.value=getCurrentPhotoName(item)
  if(photo_name.value.photo!=''){
    let photosTab=[...new Set(
          Object.values(store.state.articles[item.ga_libreart1][item.code_theme][item.ga_codearticle])
              .map(ref => ref={couleur : `${ref.code_couleur} - ${ref.couleur}`,photo:ref.photo_name})
              .filter(code => code && code.photo.trim() !== '')
      )];
    srcImage.value=`https://www.edisac.com/images/article_la/${photo_name.value.photo}` 
    photosFripe.value={
      photos:photosTab,
      firstPhoto:{couleur : photo_name.value.couleur,photo:photo_name.value.photo},
      srcImage:srcImage.value,
      PhotosCount:photosTab.length,
      index: photosTab.findIndex(el => el.photo === photo_name.value.photo)
    }
    console.log(photosFripe.value);
    
    popupVisible.value=true
  }
}
let articlePhoto=ref()
const getCurrentPhotoName = (item) => {
  articlePhoto.value=store.state.articles[item.ga_libreart1][item.code_theme][item.ga_codearticle][item.codebarre]
  if (!articlePhoto.value) return ''
  photo_name.value=articlePhoto.value.photo_name
  return {couleur:`${articlePhoto.value.code_couleur} - ${articlePhoto.value.couleur}`,photo:articlePhoto.value.photo_name}
}

// === Headers du tableau ===
const headers = [
  // { key: 'data-table-group', title: 'Category' },
  { title: 'Saison', key: 'gp_librepiece3', sortable: true },
  { title: 'Code Article', key: 'ga_codearticle', sortable: true },
  { title: 'Couleur', key: 'couleur', sortable: true },
  { title: 'EAN13', key: 'cab_secondaire', sortable: true },
  { title: 'Nature Pièce', key: 'gl_naturepieceg', sortable: true },
  { title: 'Quantité', key: 'gl_qtestock', sortable: true },
]

// === Données groupées ===
const groupedData = computed(() => {
  // Vérifier si items.value est un tableau
  if (!Array.isArray(items.value)) {
    console.warn('items.value n\'est pas un tableau:', items.value)
    return []
  }

  const grouped = {}
  
  // Filtrer uniquement les éléments avec les natures 'CC' ou 'BLC'
  const filteredItems = items.value.filter(item => 
    ['CC', 'BLC'].includes(item.gl_naturepieceg)
  )

  // Regrouper les éléments
  filteredItems.forEach(item => {
    // Créer une clé unique basée sur ga_codearticle et cab_secondaire
    const key = `${item.ga_codearticle}|${item.cab_secondaire}`
    
    if (!grouped[key]) {
      // Initialiser le groupe avec la première occurrence
      grouped[key] = {
        gp_librepiece3: item.gp_librepiece3 || 'N/A',
        ga_codearticle: item.ga_codearticle || 'N/A',
        couleur: item.couleur || 'N/A',
        cab_secondaire: item.cab_secondaire || 'N/A',
        ga_libreart1: item.ga_libreart1 || 'N/A',
        code_theme: item.code_theme || 'N/A',
        codebarre: item.codebarre || 'N/A',
        // gl_naturepieceg: item.gl_naturepieceg || 'N/A',
        gl_qtestock: 0,
        _items: []
      }
    }
    
    // Ajouter la quantité en fonction de la nature
    const quantity = Number(item.gl_qtestock) || 0
    if (item.gl_naturepieceg === 'BLC') {
      grouped[key].gl_qtestock += quantity
    } else if (item.gl_naturepieceg === 'AVS' || item.gl_naturepieceg === 'AVC') {
      grouped[key].gl_qtestock -= quantity
    }
    
    // Ajouter l'élément à la liste interne du groupe
    grouped[key]._items.push(item)
  })

  // Convertir l'objet en tableau
  let result = Object.values(grouped)

  // Appliquer le filtre par pièce si nécessaire
  if (filterGpLibrePiece.value) {
    result = result.filter(item => item.gp_librepiece3 === filterGpLibrePiece.value)
  }

  return result
})
 let groupBy=computed(()=>{
    
  // return regroupe.value?[{key:'gp_librepiece3'}]:[]
  return regroupe.value? [{ key: 'gp_librepiece3', order: 'asc' }]:[]
 })   

// === Options pour le filtre ===
const gpLibrePieceOptions = computed(() => {
  if (!Array.isArray(items.value)) {
    return []
  }
  const options = new Set()
  items.value.forEach(item => {
    if (item.gp_librepiece3) {
      options.add(item.gp_librepiece3)
    }
  })
  return Array.from(options).sort()
})

// === Méthodes ===
const refreshData = async () => {
  loading.value = true
  try {
    // Simulation d'appel API
    await new Promise(resolve => setTimeout(resolve, 500))
    // Vérifier que les données mock sont bien un tableau
    if (Array.isArray(props.mockData)) {
      items.value = props.mockData
      console.log('[INFO] Données chargées:', items.value.length, 'éléments')
      console.log('[DEBUG] Premières données:', items.value.slice(0, 3))
    } else {
      console.error('[ERROR] Les données mock ne sont pas un tableau:', props.mockData)
      items.value = []
    }
  } catch (error) {
    console.error('[ERROR] Erreur lors du chargement des données:', error)
    items.value = []
  } finally {
    loading.value = false
  }
}
async function getArticles(marque){
  store.commit('updateWaiting')
  let params=
  {   
      marques:`{${marque}}`
  }
  let url=    `https://my.edisac.com/goapi/articlesdeep`
  let config = {
  method: 'get',
  url: url,
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
  },
  params:params
  };
  return axios.request(config)
  .then((response) => {
      store.commit('addArticles',response.data.articles) 
      // console.log(response.data.articles);
      
      store.commit('updateWaiting')    
  })
  .catch((error) => {
  //console.log(error);
  });
  
}

// === Cycle de vie ===
onMounted(() => {
  refreshData()
  getArticles(['731','742','737'])
})

</script>

<style scoped>
.v-data-table :deep(.v-data-table__td) {
  padding: 4px 8px !important;
}

.v-data-table :deep(.v-data-table__th) {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
}

.v-avatar {
  border: 1px solid #ddd;
}
</style>